/**
 * @type {String}
 */
export const lcTopFilterFragment = `
  ...on ComponentLearningCenterTopFilter {
    filtersCollection(limit: 10) {
      items {
        name
        displayName
      }  
    }
  }`;
